export const sortByOptions = [
  { label: 'Combined Matches', value: 'TotalMatches' },
  { label: 'Funding Matches', value: 'TotalGrants' },
  { label: 'Tradeshow Matches', value: 'TotalSessions' },
  { label: 'Publication Matches', value: 'TotalPublications' },
  { label: 'Clinical Trial Matches', value: 'TotalClinicalTrials' },
  { label: 'Research Impact (3 Year Avg)', value: 'ThreeYearImpact' },
  { label: 'Date', value: 'Date' },
  { label: 'No. of Collaborators', value: 'TotalCollaboratorsOverall' },
];

// People Count (NEW) - uses People Matches count (not total people in org).

// Combined Matches - Total workitem count which excludes People Count (as per Contact Search).

// Funding Matches

// Tradeshow Matches

// Publication Matches

// Clinical Trial Matches

export const orgSortByOptions = [
  { label: 'Date', value: 'Date' },
  {
    label: 'Latest Funding Round',
    value: 'SuperOrganisationLatestFundingRound.AnnouncedDate',
  },
  { label: 'Contact Matches', value: 'TotalResearchers' },
  { label: 'Combined Matches', value: 'TotalMatches' },
  { label: 'Funding Matches', value: 'TotalGrants' },
  { label: 'Tradeshow Matches', value: 'TotalSessions' },
  { label: 'Publication Matches', value: 'TotalPublications' },
  { label: 'Clinical Trial Matches', value: 'TotalClinicalTrials' },
  { label: 'Org Description', value: 'OrgDescription' },
];
